/* eslint-disable react/prop-types */
import { Button } from "components/Common/button";
import { Header } from "components/Common/Header";
import { TeeTimeInfo } from "components/Common/TeeTimeInfo";

import { useEvent } from "hooks/useEvent";
import { useTeeTime } from "hooks/useTeeTime";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  addUserInTeam,
  addUserInTeeTimeCustomEvent,
  getUserDataOnce,
} from "services/firebase";

import "./styles.css";

// eslint-disable-next-line react/prop-types
function TeeTimeConfirmationComponent({ user }) {
  const navigation = useNavigate();
  const [isBooked, setIsBooked] = useState(false);

  const { eventId, teeTimeId, teamId } = useParams();

  const event = useEvent(eventId) || {};
  const teeTime = useTeeTime(eventId, teeTimeId) || {};

  async function bookTeeTime() {
    const isBookingPossible =
      !isBooked && typeof user.handicap === "number" && user.phone && eventId;

    if (isBookingPossible) {
      setIsBooked(true);
      const { isAdded, alreadyPlay } = teamId
        ? await addUserInTeam(eventId, teeTimeId, teamId, user)
        : await addUserInTeeTimeCustomEvent(eventId, teeTimeId, user);

      if (isAdded) {
        navigation(`/event/${eventId}`);
      }
      if (alreadyPlay) {
        navigation(`/event/${eventId}`);
      }
    }
    return setIsBooked(true);
  }

  if (!event.id || !teeTime.id) {
    return <p>Loading...</p>;
  }

  return (
    <div>
      <Header event={event} userData={user} hideQr />
      <div className="tee-time-confirmation--success-message">
        Success! You&apos;re signed up to play.
      </div>

      <div className="tee-time-confirmation--wrapper">
        <div className="tee-time-confirmation--textBlock">
          <div className="tee-time-confirmation--title">Your match details</div>
          <div style={{ marginTop: 16 }}>
            <TeeTimeInfo
              courseName={event?.courseName}
              teeName={event?.teeName}
              teeTimeTimestamp={teeTime?.teeTime}
              users={teeTime?.users}
              teeTimeString={teeTime?.teeTimeString}
              fiveSomes={event.fiveSomes}
              matchPlay={event.matchType === 3 || event.matchType === 8}
            />
          </div>
        </div>
        <div className="tee-time-confirmation--message">
          <Button
            style={{ width: "100%" }}
            title="View Match"
            onPress={() => bookTeeTime()}
            blocked={isBooked}
          />
        </div>
      </div>
    </div>
  );
}

function TeeTimeConfirmation(props) {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        // eslint-disable-next-line react/destructuring-assignment, react/prop-types
        const data = await getUserDataOnce(props.uid);
        setUserData(data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
    fetchData();
    // eslint-disable-next-line react/destructuring-assignment, react/prop-types
  }, [props.uid]);

  return (
    userData && <TeeTimeConfirmationComponent {...props} user={userData} />
  );
}

export { TeeTimeConfirmation };
